import { uuid } from '@primer-io/sdk-utils/uuid';
import { loadPrimer } from './load';
import { getAnalytics } from '@primer-sdk-web/analytics/analytics';
import { initGlobalErrorMonitoring } from '@primer-sdk-web/errors/initGlobalErrorMonitoring';
import { timerIdCheckoutFlowMap } from '@primer-sdk-web/analytics';
import { SDKError } from '@primer-sdk-web/errors/SDKError';
import {
  makeCrashEventCall,
  postCrashEventBackup,
} from '@primer-sdk-web/errors/utils/makeCrashEventCall';

export const preloadPrimer = async () => {
  const checkoutSessionId = uuid();
  try {
    const analytics = getAnalytics(checkoutSessionId);
    try {
      initGlobalErrorMonitoring(checkoutSessionId, analytics);
      analytics.sdkFunctionEvent({ name: 'preloadPrimer' });
      analytics.timerStart({ id: timerIdCheckoutFlowMap['preloadPrimer'] });
      await loadPrimer(analytics);
      analytics.timerEnd({ id: timerIdCheckoutFlowMap['preloadPrimer'] });
    } catch (error) {
      const sdkError = SDKError.from(error);
      if (!sdkError.isReported) {
        makeCrashEventCall({
          checkoutSessionId: checkoutSessionId,
          analytics: analytics,
          error: sdkError,
          reporter: 'preloadPrimer level 1',
        });
        sdkError.markAsReported();
      }
      throw sdkError;
    }
  } catch (error) {
    const sdkError = SDKError.from(error);
    if (!sdkError.isReported) {
      postCrashEventBackup(
        checkoutSessionId,
        sdkError,
        'preloadPrimer level 0',
      );
      sdkError.markAsReported();
    }
    throw sdkError;
  }
};
